import { Component, OnDestroy, OnInit } from '@angular/core';
import { SideNavigationService } from '@sb-tools/typescript/services/side-navigation.service';
import { AuthenticationService } from '@sb-tools/typescript/authentication/authentication.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { CommonDataForSettingsService } from '@core/services/common-data-for-settings.service';
import { UserDataService } from '@sb-tools/typescript/services/user-data.service';
import { CommonDataService } from '@sb-tools/typescript/services/common-data.service';
import { SidenavComponent } from '@sb-tools/typescript/components/sidenav/sidenav.component';
import { LeftMenuComponent } from '@shared/components/left-menu/left-menu.component';
import { TopMenuComponent } from '@shared/components/top-menu/top-menu.component';
import { RouterOutlet } from '@angular/router';

@Component({
    selector: 'app-layout-with-left-menu',
    templateUrl: './layout-with-left-menu.component.html',
    styleUrls: ['./layout-with-left-menu.component.scss'],
    imports: [SidenavComponent, LeftMenuComponent, TopMenuComponent, RouterOutlet],
})
export class LayoutWithLeftMenuComponent implements OnDestroy, OnInit {
    communityName: string;

    private unsubscriber = new Subject<void>();

    constructor(
        public sideNavigationService: SideNavigationService,
        private commonDataForSettingsService: CommonDataForSettingsService,
        private authenticationService: AuthenticationService,
        private userDataService: UserDataService,
        private commonDataService: CommonDataService,
    ) {}

    ngOnInit() {
        // todo: fix if after reorganaizong common services
        this.commonDataForSettingsService.communityName = this.authenticationService.community;
        this.commonDataService.community = this.authenticationService.community;
        this.commonDataService.communityName = this.authenticationService.community;

        this.listenCommunityUser();
    }

    private listenCommunityUser() {
        this.commonDataForSettingsService.user$.pipe(takeUntil(this.unsubscriber)).subscribe(() => {
            this.userDataService.getCurrentUser().subscribe((user) => {
                this.commonDataService.user = user;
            });
        });
    }

    ngOnDestroy() {
        this.unsubscriber.next();
        this.unsubscriber.complete();
    }
}
